import { initializeFilter } from "./integrator-movement-factory";

export type DefaultEmptyValue = null | '';

export type IntegratorMovementStatus = 'PENDING' | 'WAIT_SUBMISSION' | 'INTEGRATION_SUCCESS' | 'INTEGRATION_ERROR' | 'CANCELED';

export type IntegratorMovementOrigin = 'CDP' | 'MOV';

export type IntegratorMovementType = 'INSERT' | 'UPDATE' | 'UPDATE_SUBCONTRACT' | 'EXCLUSION';

export type IntegratorMovementFilter = {
  id: number | null;
  financialGroup: number | null;
  contractId: number | null;
  subContractId: number | null;
  name: string | null;
  insuredDocumentNumber: number | null;
  movementIntegradoraType: IntegratorMovementType[] | [];
  origin: IntegratorMovementOrigin[];
  status: IntegratorMovementStatus[] | [];
  carrierIds: number[];
  createdDateStart: string | null;
  createdDateEnd: string | null;
  page: number;
  size: number;
  sort: string;
}

export type IntegratorMovement = {
  address: string | null;
  addressCity: string | null;
  addressComplement: string | null;
  addressNeighborhood: string | null;
  addressNumber: string | null;
  addressState: string | null;
  beneficiaryCard: string | null;
  benefitType?: string | null;
  beneficiaryType: "HOLDER" | "DEPENDENT";
  birthDate: string | null;
  cadastralPositionId: string | null;
  carrierId: string | null;
  contractId: string | null;
  createdAt: string | null;
  degreeKinship: number | null;
  email: number;
  endDate: string | null;
  financialGroupId: string | null;
  gender: string | null;
  holderDocumentNumber: string | null;
  holderName: string | null;
  id: number;
  insuredDocumentNumber: string | null;
  insuredName: string | null;
  policy?: string | null;
  subContract?: string | null;
  integradoraFamilyCode: string | null;
  integradoraFamilyCodeSeq: string | null;
  integradoraPlanCode: string | null;
  integradoraSubContractCode: string | null;
  maritalStatus: string | null;
  motherName: string | null;
  movementIntegradoraType: string | null;
  movementRecordId: number | null;
  origin: string | null;
  planId: number | null;
  previousContractId: string | null;
  rgDocumentIdentify: string | null;
  rgDocumentIssuingBody: string | null;
  startDate: string | null;
  status: string | null;
  subContractId: number | null;
  updatedAt: string | null;
}

export class IntegratorMovementsModel {
  integratorMovementFilter: IntegratorMovementFilter;
  integratorMovements: IntegratorMovement[] | [];
  loadingPage: boolean;
  totalPages: number | null;
  totalElements: number | null;
  constructor() {
    this.integratorMovementFilter = initializeFilter();
    this.integratorMovements = [];
    this.loadingPage = false;
    this.totalPages = null;
    this.totalElements = null;
  }
}
